export const appliance = 'appliance';
export const appliances = 'appliances';
export const appliancesArticle = 'an';
